import { Component, input, output } from '@angular/core';
import { CommentComponent } from '../../molecules/comment/comment.component';
import { HighlightInsertRowDirective } from '../../directives/highlight-insert-row/highlight-insert-row.directive';
import type { CommentItem } from './comment-list.interfaces';

@Component({
  selector: 'ocp-comment-list',
  imports: [CommentComponent, HighlightInsertRowDirective],
  templateUrl: './comment-list.component.html',
  styleUrl: './comment-list.component.scss',
})
export class CommentListComponent {
  readonly comments = input.required<CommentItem[]>();
  readonly showDivider = input(false);

  readonly commentClose = output<CommentItem>();

  protected onCommentClose(comment: CommentItem): void {
    this.commentClose.emit(comment);
  }
}
